export default {
  title: 'Snelkoppelingen',
  links: {
    reservations: 'Reserveringen',
    orders_portal: 'Terminallogin',
    closed: 'Gesloten?',
    menu: 'Menu wijzigen',
    payouts: 'Uitbetalingsrapporten',
    opening_hours: 'Openingstijden',
  },
};
